import columns from "../../../../../react-table/helpers/columns";
import {
  sumTotal,
  totalRowRatio,
} from "../../../../../react-table/helpers/rowTotals";
import ReportDefinitions from "../../../../../common/config/ReportDefinitions";

export function getDetailsTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row
    ? {
        reportId:
          ReportDefinitions.RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS.id,
        mainReportId:
          ReportDefinitions.RECEPTACLES_IN_PRECON_NOT_IN_PREDES_SUMMARY.id,
        requestParams: {
          operFrom: rowInfo.row["origin.operator"], // eslint-disable-line
          operTo: rowInfo.row["destination.operator"], // eslint-disable-line
          impcFrom: rowInfo.row["origin.impc"], // eslint-disable-line
          impcTo: rowInfo.row["destination.impc"], // eslint-disable-line
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      }
    : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    NavigationWithFooterColumn,
    NavigationWithFooterPercentageColumn,
  } = columns(data);

  return [
    {
      Header: "PRECON",
      columns: [
        new TextColumn("Sender", "precon.sender"),
        new TextColumn("Receiver", "precon.receiver"),
        new TextColumn("Sending mailbox", "precon.sendingMailbox"),
        new TextColumn("Receiving mailbox", "precon.receivingMailbox"),
      ],
    },
    {
      Header: "Origin IMPC",
      columns: [
        new TextColumn("Operator", "origin.operator"),
        new TextColumn("Code", "origin.impc"),
      ],
    },
    {
      Header: "Destination IMPC",
      columns: [
        new TextColumn("Operator", "destination.operator"),
        new TextColumn("Code", "destination.impc").withTotalHeader("Total"),
      ],
    },
    {
      Header: "Receptacles",
      columns: [
        new NavigationWithFooterColumn(
          new NonZeroNumberColumn(
            "PRECON",
            "receptacles.precon"
          ).withTotalHeader(sumTotal),
          getDetailsTabNavigationProps
        ),
        new NavigationWithFooterColumn(
          new NonZeroNumberColumn(
            "PREDES",
            "receptacles.predes"
          ).withTotalHeader(sumTotal),
          getDetailsTabNavigationProps
        ),
        new NavigationWithFooterColumn(
          new NonZeroNumberColumn(
            "PRECON - PREDES",
            "receptacles.diff"
          ).withTotalHeader(sumTotal),
          getDetailsTabNavigationProps
        ),
        new NavigationWithFooterPercentageColumn(
          new NonZeroPercentageColumn(
            "PREDES / PRECON",
            "receptacles.pct"
          ).withTotalHeader(
            totalRowRatio(["receptacles.predes", "receptacles.precon"])
          ),
          getDetailsTabNavigationProps
        ),
      ],
      drillDownLink: {
        reportId:
          ReportDefinitions.RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS.id,
        mainReportId:
          ReportDefinitions.RECEPTACLES_IN_PRECON_NOT_IN_PREDES_SUMMARY.id,
        requestParams: {
          isTotal: true,
          impcFrom: "*",
          impcTo: "*",
          operFrom: "*",
          operTo: "*",
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
